import buildTourTravelerRows from '../buildTourTravelerRows';
import calculateAge from '../calculateAge';
import getTourTravelDate from '../getTourTravelDate';
import { getTourRateAgeError, hasCheckableAgeBand } from '../getTourRateAge';
import validateName from './validateName';
import diagnoseNameFailure, { buildNameFailureMessage } from './diagnoseNameFailure';

const readNameError = (name) => {
  const message =
    buildNameFailureMessage(diagnoseNameFailure(name)) ||
    'The name must have at least 2 characters and contain only letters, spaces, or hyphens.';
  return message;
};

export const validateTourBookingQuestions = (toursToBook, tourTravelerQuestions) => {
  const invalidSegments = {};

  (toursToBook || []).forEach((tourItinerary) => {
    const hasQuestion = !!(tourItinerary?.tour?.bookingQuestions || '').trim();
    if (!tourItinerary.tour?.areBookingQuestionsMandatory || !hasQuestion) {
      return;
    }

    const segmentId = tourItinerary.tripSegmentId;
    const answer = (tourTravelerQuestions && tourTravelerQuestions[segmentId]) || '';
    if (!answer.trim()) {
      invalidSegments[segmentId] = 'The operator requires an answer to this question.';
    }
  });

  return invalidSegments;
};

const validateOneTour = (tourItinerary, tourTravelers) => {
  const places = buildTourTravelerRows(tourItinerary);
  const segmentId = tourItinerary.tripSegmentId;
  const rows = (tourTravelers && tourTravelers[segmentId]) || [];
  const invalidPlaces = {};

  places.forEach((place, index) => {
    const traveler = rows[index] || {};
    const errors = {};

    // The operator reads the names under a rate as a comma-separated list, one place per entry,
    // so the names keep to the passenger rule: letters, spaces and hyphens.
    if (!(traveler.firstName || '').trim()) {
      errors.firstName = 'First name is required.';
    } else if (!validateName(traveler.firstName)) {
      errors.firstName = readNameError(traveler.firstName);
    }
    if (!(traveler.lastName || '').trim()) {
      errors.lastName = 'Last name is required.';
    } else if (!validateName(traveler.lastName)) {
      errors.lastName = readNameError(traveler.lastName);
    }
    if (hasCheckableAgeBand(place.rate)) {
      if (!traveler.birthDate) {
        errors.birthDate = 'A date of birth is required for this rate.';
      } else {
        const ageError = getTourRateAgeError(
          place.rate,
          calculateAge(traveler.birthDate, getTourTravelDate(tourItinerary)),
        );
        if (ageError) {
          errors.birthDate = ageError;
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      invalidPlaces[index] = errors;
    }
  });

  const invalidSegments = {};
  if (Object.keys(invalidPlaces).length > 0) {
    invalidSegments[segmentId] = invalidPlaces;
  }
  return invalidSegments;
};

const validateTourTravelers = (toursToBook, tourTravelers) => {
  const invalidSegments = {};

  (toursToBook || []).forEach((tourItinerary) => {
    Object.assign(invalidSegments, validateOneTour(tourItinerary, tourTravelers));
  });

  return invalidSegments;
};

export default validateTourTravelers;
